export default {"src":"/_next/static/media/logo-mobile.09ad16ba.svg","height":17,"width":156,"blurWidth":0,"blurHeight":0};